export class EventoOrdenacaoConstants {

  public static readonly LISTA = [
    {
      label: 'Ano',
      value: 'ano'
    },
    {
      label: 'Tipo de evento',
      value: 'tipoevento'
    },
    {
      label: 'Situação',
      value: 'situacao'
    },
  ]
}
